import React from "react";
import {Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis} from "recharts";

interface BarChartData {
    name: string;
    count: number;
}

interface HolidayBarChartProps {
    data: BarChartData[]
}

function HolidayBarChart(props: HolidayBarChartProps) {

    return (
        <ResponsiveContainer width="100%" height={200}>
            <BarChart
                data={props.data}
                margin={{top: 4, right: 8, left: -40, bottom: 0}}
                barSize={24}
                barGap={1}
            >
                <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" vertical={false} />
                <XAxis
                    dataKey="name"
                    tick={{ fontSize: 11, fill: '#64748b' }}
                    axisLine={false}
                    tickLine={false}
                />
                <YAxis
                    allowDecimals={false}
                    tick={{ fontSize: 11, fill: '#64748b' }}
                    axisLine={false}
                    tickLine={false}
                />
                <Tooltip
                    contentStyle={{
                        background: '#fff',
                        border: '1px solid #e2e8f0',
                        borderRadius: '8px',
                        fontSize: '12px',
                        fontWeight: 500,
                        color: '#0f172a',
                    }}
                    cursor={{ fill: 'rgba(79,70,229,0.06)' }}
                />
                <Bar dataKey="count" name="Total" fill="#7a73eb" radius={[3, 3, 0, 0]} maxBarSize={24} />
            </BarChart>
        </ResponsiveContainer>
    )
}

export default HolidayBarChart;